import { render, staticRenderFns } from "./AdditionalItems.vue?vue&type=template&id=fb3ee74c&scoped=true&lang=pug"
import script from "./AdditionalItems.vue?vue&type=script&lang=js"
export * from "./AdditionalItems.vue?vue&type=script&lang=js"
import style0 from "./AdditionalItems.vue?vue&type=style&index=0&id=fb3ee74c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb3ee74c",
  null
  
)

export default component.exports